<template>
  <LinkBoosterList :links>
    <template #title>
      <h3 class="heading-3" data-selector="tags-pp-title">
        {{ i18n(translations.title) }}
      </h3>
    </template>
  </LinkBoosterList>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import LinkBoosterList from '~/scopes/seo/components/LinkBoosterList.vue'
import type { LinkBooster } from '~~/shared/api/internal-links/types'

import translations from './SeoLinks.translations'

const i18n = useI18n()
const { links } = defineProps<{ links: LinkBooster[] }>()
</script>
